module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "test-sign-up"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "填写报名资料",
      "visible": _vm.signUpData,
      "width": "760px"
    },
    on: {
      "update:visible": function($event) {
        _vm.signUpData = $event
      }
    }
  }, [_c('div', {
    staticClass: "sign-up-data"
  }, [_c('p', [_vm._v("请完善一下信息，我们的工作人员会及时联系您")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "left"
  }, [_vm._v("学校\n            "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.school_name),
      callback: function($$v) {
        _vm.school_name = $$v
      },
      expression: "school_name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "left"
  }, [_vm._v("姓名\n            "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.userName),
      callback: function($$v) {
        _vm.userName = $$v
      },
      expression: "userName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "left"
  }, [_vm._v("手机\n            "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _c('el-input', {
    attrs: {
      "placeholder": "请输入内容",
      "minlength": "6",
      "maxlength": "11"
    },
    model: {
      value: (_vm.mobile),
      callback: function($$v) {
        _vm.mobile = $$v
      },
      expression: "mobile"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "left",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("考试科目\n          "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('span', {
    staticClass: "subject-box"
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.subject),
      callback: function($$v) {
        _vm.subject = $$v
      },
      expression: "subject"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "语文"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "数学(文)"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "数学(理)"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "英语"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "文科综合"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "理科综合"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "red"
  }, [_vm._v("注：不参加联考的科目请自行取消勾选")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "btn-add-sing-up",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("提交")])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提交成功",
      "visible": _vm.signUpSuccess,
      "width": "760px"
    },
    on: {
      "update:visible": function($event) {
        _vm.signUpSuccess = $event
      }
    }
  }, [_c('div', {
    staticClass: "sign-up-success"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/img-save-success.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "msg-box"
  }, [_c('p', {
    staticClass: "big-msg"
  }, [_vm._v("恭喜你！提交成功")]), _vm._v(" "), _c('p', {
    staticClass: "msg"
  }, [_vm._v("我们的工作人员将会及时联系您，并妥善保管您的相关信息！")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/img-sing-up-top.png"),
      "alt": "",
      "usemap": "#suspension"
    }
  }), _vm._v(" "), _c('map', {
    attrs: {
      "name": "suspension"
    }
  }, [_c('area', {
    staticClass: "btn-add",
    attrs: {
      "shape": "rect",
      "coords": "1080,16,1180,44",
      "alt": "点击报名"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/img-sing-up-left.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/img-yaoqinghang.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticStyle: {
      "text-indent": "0"
    }
  }, [_vm._v("全国各高中学校：")]), _vm._v(" "), _c('p', [_vm._v("为帮助各高中学校检验本校高三复习效果，帮助学生找到复习中存在的问题，满足全国师生在备考时各项需求，\n          达到错因精准定位，排名精准评估，成绩精准提升的目的，风向标教育联合全国千余所高级中学，开展本次"), _c('span', {
    staticClass: "red"
  }, [_vm._v("全学科、高保真")]), _vm._v("的高三联合质量评估考试。")]), _vm._v(" "), _c('p', [_vm._v("通过本次联合质量评估，学校可以清晰掌握本校复习各项指标，梳理各班、各层次学生的复习情况，为接下来的复习定标准、找方向。利用风向标智能精准教学系统，为每一所学校提供专项报告、每一名教师提供专属教案，每一位学生提供个性化提升方案。\n          为了实现教师精准备考、学生个性化复习，风向标教育联合高考命题专家，举办线上联合评估质量分析会议，进一步明确复习亮点和不足，打造行之有效的精准复习备考策略。")]), _vm._v(" "), _c('p', {
    staticClass: "text-title"
  }, [_vm._v("一、报名方式")]), _vm._v(" "), _c('p', [_vm._v("知心慧学项目学校通过学管登录学管端进行考试报名；（学校告知在校学管报名）")]), _vm._v(" "), _c('p', [_vm._v("其他学校可以通过知心慧学官网提交报名信息，或者通过业务经理进行报名。")]), _vm._v(" "), _c('p', [_vm._v("采用邮箱报名：zhao@fxbjy.com")]), _vm._v(" "), _c('p', {
    staticClass: "text-title"
  }, [_vm._v("二、组织考试")]), _vm._v(" "), _c('p', [_vm._v("考试时间：2019年12月19日-20日（具体科目时间安排见下表）")]), _vm._v(" "), _c('table', {
    staticClass: "table-sing-up",
    attrs: {
      "border": "1"
    }
  }, [_c('tr', {
    staticClass: "table-head"
  }, [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("考试时间安排")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "117px"
    }
  }, [_vm._v("适用范围")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "200px"
    }
  }, [_vm._v("时间")]), _vm._v(" "), _c('td', [_vm._v("上午")]), _vm._v(" "), _c('td', [_vm._v("下午")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("全国")]), _vm._v(" "), _c('td', [_vm._v("12月19日")]), _vm._v(" "), _c('td', [_vm._v("语文  09:00-11:30")]), _vm._v(" "), _c('td', [_vm._v("数学（文理）  15:00-17:00")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("全国")]), _vm._v(" "), _c('td', [_vm._v("12月20日")]), _vm._v(" "), _c('td', [_vm._v("文科综合/理科综合  09:00-11:30")]), _vm._v(" "), _c('td', [_vm._v("英语  15:00-17:00")])])]), _vm._v(" "), _c('p', [_vm._v("为保证本次联合质量评估的公平、公正，参评学校名称在系统内均以"), _c('span', {
    staticClass: "red"
  }, [_vm._v("特定代码的方式")]), _vm._v("呈现。系统"), _c('span', {
    staticClass: "red"
  }, [_vm._v("提前2小时")]), _vm._v("发布试卷，由学管（或学校相关人员）按时下载并打印试卷、答题卡。")]), _vm._v(" "), _c('p', [_vm._v("考试结束后学管（或学校相关人员）扫描答题卡。")]), _vm._v(" "), _c('p', [_vm._v("参考学校的老师，在12月21日12点前完成所有线上阅卷（阅卷规则和时间"), _c('span', {
    staticClass: "red"
  }, [_vm._v("详见附件1")]), _vm._v("）。")]), _vm._v(" "), _c('p', {
    staticClass: "text-title"
  }, [_vm._v("三、成绩报告")]), _vm._v(" "), _c('p', [_vm._v("2019年12月23日-24日，老师可以登录风向标智能精准教学系统（知心慧学）在线查看本校成绩报告，也可以在线查看本省整体综合报告。")]), _vm._v(" "), _c('p', {
    staticClass: "text-title"
  }, [_vm._v("四、联合质量分析会议")]), _vm._v(" "), _c('p', [_vm._v("2019年12月26日及27日举办线上质量分析会议，帮助学校进一步精准找到原因，明确本次联评存在的问题，结合今年高考预测，共同打造高效的二轮精准备考方案。（具体科目时间安排见下表）")]), _vm._v(" "), _c('table', {
    staticClass: "table-sing-up",
    attrs: {
      "border": "1"
    }
  }, [_c('tr', {
    staticClass: "table-head"
  }, [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("线上质量分析会议时间安排")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "117px"
    }
  }, [_vm._v("适用范围")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "200px"
    }
  }, [_vm._v("时间")]), _vm._v(" "), _c('td', [_vm._v("上午")]), _vm._v(" "), _c('td', [_vm._v("下午")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("全国")]), _vm._v(" "), _c('td', [_vm._v("12月26日")]), _vm._v(" "), _c('td', [_vm._v("语文  09:00-11:30")]), _vm._v(" "), _c('td', [_vm._v("数学（文理）  15:00-17:00")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("全国")]), _vm._v(" "), _c('td', [_vm._v("12月27日")]), _vm._v(" "), _c('td', [_vm._v("文科综合/理科综合  09:00-11:30")]), _vm._v(" "), _c('td', [_vm._v("英语  15:00-17:00")])])]), _vm._v(" "), _c('p', [_vm._v("阅卷规则详见"), _c('span', {
    staticClass: "red"
  }, [_vm._v("附件1")]), _vm._v("。")]), _vm._v(" "), _c('p', [_vm._v("考试的各科考察范围及命卷细目详情见"), _c('span', {
    staticClass: "red"
  }, [_vm._v("附件2")]), _vm._v("。")]), _vm._v(" "), _c('p', [_vm._v("诚挚邀请！")]), _vm._v(" "), _c('div', {
    staticClass: "corporate-name"
  }, [_c('img', {
    staticClass: "seal",
    attrs: {
      "src": require("../../assets/img/img-seal.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_c('p', [_vm._v("江西风向标教育科技有限公司")]), _vm._v(" "), _c('p', [_vm._v("2019年12月3日")])])]), _vm._v(" "), _c('div', {
    staticClass: "down"
  }, [_c('p', [_vm._v("附件1:\n            "), _c('a', {
    attrs: {
      "href": "/static/lk-yj.PNG",
      "target": "_blank"
    }
  }, [_vm._v("教师线上阅卷规则说明(点击预览)")])]), _vm._v(" "), _c('p', [_vm._v("附件2:\n            "), _c('a', {
    attrs: {
      "href": "/static/lk-km.PNG",
      "target": "_blank"
    }
  }, [_vm._v("命卷细目表及各科考试安排(点击预览)")])])])]), _vm._v(" "), _c('span', {
    staticClass: "btn-sing-up"
  }, [_vm._v("我要报名")]), _vm._v(" "), _c('img', {
    staticClass: "img-sing-up-bottom",
    attrs: {
      "src": require("../../assets/img/img-sing-up-bottom.gif"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/img/img-sing-up-right.gif"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c39feee","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/joint-assess/signUpListTwo.vue
// module id = 518
// module chunks = 2